import { z } from 'zod'
import { Model } from './architecture'

export const ImageCodeValidation = z.object({
  // @TODO: We must to replace this plain text by an enum
  value: z.string({ required_error: '[ImageCode] value is required' }),
})

export class ImageCode extends Model {
  static create({ value }: z.infer<typeof ImageCodeValidation>) {
    ImageCodeValidation.parse({ value })
    return new ImageCode(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
